<template>
  <f7-actions
    v-model:opened="isActionsOpened"
    grid
    class="new-expedition-actions"
  >
    <f7-actions-group>
      <f7-actions-label>{{ $t('commercialization.expeditionsNoSalesOrder.newExpeditionAction.createExpedition') }}</f7-actions-label>

      <f7-actions-button @click="navigateToWithoutOrder">
        <template #media>
          <img
            src="@/static/icons/ic_noorder.svg"
            width="45"
          >
        </template>
        <span>{{ $t('commercialization.expeditionsNoSalesOrder.newExpeditionAction.withoutOrder') }}</span>
      </f7-actions-button>

      <f7-actions-button @click="navigateToWithOrder">
        <template #media>
          <img
            src="@/static/icons/ic_yesorder.svg"
            width="45"
          >
        </template>
        <span>{{ $t('commercialization.expeditionsNoSalesOrder.newExpeditionAction.withOrder') }}</span>
      </f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script setup>
// @ts-check

import { ref } from 'vue';
import { f7 } from 'framework7-vue';

const isActionsOpened = ref(false);

/**
 * @public
 * @returns {void}
 */
function openActions() {
  isActionsOpened.value = true;
}

function closeActions() {
  isActionsOpened.value = false;
}

function navigateToWithoutOrder() {
  f7.views.main.router.navigate(
    '/commercialisation/expedition/noSalesOrder/frmExpeditionNewNoSalesOrder',
  );
}

function navigateToWithOrder() {
  f7.views.main.router.navigate(
    '/commercialisation/expedition/frmExpeditionEditLines',
  );
}

defineExpose({
  openActions,
  closeActions,
});
</script>

<style scoped lang="scss">
.new-expedition-actions {
  .actions-button {
    flex: 1;
  }

  :deep(.actions-button-media) {
    justify-content: center;

    i {
      font-size: 32px;
    }
  }
}
</style>
